module.exports = __webpack_public_path__ + "img/ic_foot_hight_8.667a791a.png";